import React from "react";
import { Box, useTheme } from "@mui/material";
import { useColourMode } from "../contexts/ColourContext";
import CheckIcon from "@mui/icons-material/Check"; // Tick icon for selected color
import { shadeColour } from "../functions";

const AccentToggle = () => {
  const { accentColour, accentColours, handleSetAccentColour } =
    useColourMode();
  const colourTheme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: "0.5rem",
      }}
    >
      {Object.keys(accentColours).map((colour) => (
        <Box
          key={colour}
          onClick={() => handleSetAccentColour(colour)}
          sx={{
            width: "1.5rem",
            height: "1.5rem",
            borderRadius: "50%",
            background: `linear-gradient(145deg, ${
              accentColours[colour]
            }, ${shadeColour(accentColours[colour], -20)})`, // Gradient for depth
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            position: "relative",
            ml: "0.5rem",
            boxShadow: "0 4px 6px rgba(0,0,0,0.2), 0 2px 4px rgba(0,0,0,0.1)", // Add shadow for depth
            transition: "all 0.3s ease", // Smooth transition for hover effects
            "&:hover": {
              boxShadow:
                "0 6px 8px rgba(0,0,0,0.3), 0 3px 6px rgba(0,0,0,0.15)", // More depth on hover
              transform: "translateY(-2px)", // Slight lift on hover
            },
          }}
        >
          {colour === accentColour && (
            <CheckIcon
              sx={{ color: colourTheme.palette.text.primary, fontSize: "1rem" }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};

export default AccentToggle;
